import React from 'react';
import './App.css';
import 'tachyons';

const Footer =() => {
    return (

        <footer className="pv1">
            <small className="f6 db tc">© 2020 <b>Website made by Chantelle Landman</b>. All Rights Reserved</small>
        </footer>

    )
};

export default Footer